const getIdIfExist = (item) => item instanceof Object && 'id' in item ? item.id : item;

const defaultOptions = {
  filterFalsyItems: false,
};

export const getEntitiesIds = (obj, { filterEmptyItems } = defaultOptions) => {
  return Object.keys(obj).reduce((newObj, key) => {
    if (filterEmptyItems && typeof obj[key] !== 'boolean' && !obj[key]) return newObj;

    if (Array.isArray(obj[key])) {
      newObj[key] = obj[key].map(getIdIfExist);
    } else {
      newObj[key] = getIdIfExist(obj[key]);
    }

    return newObj;
  }, {});
};
